import { render, staticRenderFns } from "./whatsAppChat.vue?vue&type=template&id=27eb8dd4&scoped=true&"
import script from "./whatsAppChat.vue?vue&type=script&lang=ts&"
export * from "./whatsAppChat.vue?vue&type=script&lang=ts&"
import style0 from "./whatsAppChat.vue?vue&type=style&index=0&id=27eb8dd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb8dd4",
  null
  
)

export default component.exports